
const config = {
     //BASE_URL: 'http://localhost:8000/',
    BASE_URL: 'https://ekrak.com/',
    //BASE_URL: 'http://localhost/justnowapi/public/',
    OUTSIDE_URL: 'http://localhost/justnowapp/public/various/'
}

export default config
